.wrapper {
    position: relative;
    overflow-y: auto;
    height: 100%;
    width: 100%;
    font-family: var(--tempest-font-sans);
    -webkit-overflow-scrolling: touch;
}

.indicator {
    position: absolute;
    top: var(--tempest-space-2);
    left: 50%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: var(--tempest-radius-full);
    background-color: var(--tempest-surface);
    color: var(--tempest-primary);
    box-shadow: var(--tempest-shadow-lg);
    pointer-events: none;
    transform: translateX(-50%);
}

.content {
    will-change: transform;
}

.content.dragging {
    transition: transform 0.2s ease;
}
